import * as React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import WrapperComponent from "../../components/wrapper/wrapper.component";
import {
  FormChoice,
  FormChoiceOption,
  Product,
  PRODUCT_DATA,
} from "../../constants/products";
import FullBleedComponent from "../../components/full-bleed/full-bleed.component";
import { FormResponse } from "../../components/form/form.component";
import {
  ContactSection,
  Copy,
  FormGrid,
  FormSection,
  LeadCopy,
  ProductContent,
  VideoBanner,
} from "./w-series.styles";
import { WSeriesFormComponent } from "../../components/w-series-form/w-series-form.component";

const WSeriesRoute = () => {
  const contactRef = React.useRef<null | HTMLDivElement>(null);

  return (
    <>
      <Helmet>
        <title>{`W Series`}</title>
        <meta name="description" content={""} />
      </Helmet>
      <WrapperComponent>
        <FullBleedComponent>
          <VideoBanner>
            <video width="100%" height="auto" autoPlay loop muted>
              <source
                src="https://7thsense.one/storage/app/uploads/public/698/1b5/bd0/6981b5bd019f4957496230.mp4"
                type="video/mp4"
              />
            </video>
          </VideoBanner>
        </FullBleedComponent>

        <ProductContent>
          <FadeInWhenVisible>
            <LeadCopy>Something BIG is coming. Summer 2026.</LeadCopy>
          </FadeInWhenVisible>
          <FadeInWhenVisible>
            <Copy>
              Do you have a project that needs the future of generative media
              servers?...
            </Copy>
          </FadeInWhenVisible>
          <FadeInWhenVisible>
            <Copy>
              Sign up below. Be the first to know about what's next from
              7thSense.
            </Copy>
          </FadeInWhenVisible>
        </ProductContent>

        <FullBleedComponent>
          <ContactSection>
            <WrapperComponent>
              <FormGrid>
                <FormSection ref={contactRef}>
                  <WSeriesFormComponent />
                </FormSection>
              </FormGrid>
            </WrapperComponent>
          </ContactSection>
        </FullBleedComponent>
      </WrapperComponent>
    </>
  );
};

export default WSeriesRoute;

type Props = {
  children: string | JSX.Element | JSX.Element[];
};

export const FadeInWhenVisible = (props: Props) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.75 }}
      variants={{
        visible: { opacity: 1, x: 0, y: 0 },
        hidden: { opacity: 0, x: -100, y: 100 },
      }}
    >
      {props?.children}
    </motion.div>
  );
};

export const FadeInImage = (props: Props) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.75 }}
      variants={{
        visible: { opacity: 1, x: 0, y: 0 },
        hidden: { opacity: 0, x: 100, y: 100 },
      }}
    >
      {props?.children}
    </motion.div>
  );
};
